module.exports = __webpack_public_path__ + "static/34-786736c5cd9fe97dd231b27da7aa5396.jpg";